import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/u757177604/domains/plotae.com/hbuilds/source/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/u757177604/domains/plotae.com/hbuilds/source/src/components/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/u757177604/domains/plotae.com/hbuilds/source/src/components/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/u757177604/domains/plotae.com/hbuilds/source/src/components/ui/AppImage.tsx");
